import { useState, useEffect, useCallback } from "react";
import fscreen from "fscreen";
import {
  ArrowsPointingOutIcon,
  ArrowsPointingInIcon,
} from "@heroicons/react/24/solid";

export default function FullScreenToggle({ element }) {
  const [inFullscreenMode, setInFullscreenMode] = useState(false);

  const handleFullscreenChange = useCallback((e) => {
    if (fscreen.fullscreenElement !== null) {
      setInFullscreenMode(true);
    } else {
      setInFullscreenMode(false);
    }
  }, []);

  const handleFullscreenError = useCallback((e) => {
    console.log("Fullscreen Error", e);
  }, []);

  useEffect(() => {
    if (fscreen.fullscreenEnabled) {
      fscreen.addEventListener(
        "fullscreenchange",
        handleFullscreenChange,
        false,
      );
      fscreen.addEventListener("fullscreenerror", handleFullscreenError, false);
      return () => {
        fscreen.removeEventListener("fullscreenchange", handleFullscreenChange);
        fscreen.removeEventListener("fullscreenerror", handleFullscreenError);
      };
    }
  });

  const toggleFullscreen = useCallback(() => {
    if (inFullscreenMode) {
      fscreen.exitFullscreen();
    } else {
      fscreen.requestFullscreen(element.current);
    }
  }, [element, inFullscreenMode]);

  return (
    fscreen.fullscreenEnabled && (
      <button onClick={toggleFullscreen} className="absolute right-0 top-0 p-5">
        {(inFullscreenMode && (
          <ArrowsPointingInIcon className="text-neutral h-6 w-6" />
        )) || <ArrowsPointingOutIcon className="text-neutral h-6 w-6" />}
      </button>
    )
  );
}
